module.exports = __webpack_public_path__ + "static/media/CINJ.c21942c6.svg";